// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.14.0 (commit 3ac273e970212dd613e57f4c312c49a9ab8ccb50).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AcceptInvitationReducer from "./accept_invitation_reducer";
import AddPreapprovedEmailReducer from "./add_preapproved_email_reducer";
import ApplySingleSkippedUpdateReducer from "./apply_single_skipped_update_reducer";
import ApproveModuleUpdateReducer from "./approve_module_update_reducer";
import ApproveModuleUpdateClearReducer from "./approve_module_update_clear_reducer";
import ApproveModuleUpdatesReducer from "./approve_module_updates_reducer";
import ApproveModuleUpdatesClearReducer from "./approve_module_updates_clear_reducer";
import ArchiveProjectReducer from "./archive_project_reducer";
import AssignAdminRoleReducer from "./assign_admin_role_reducer";
import AssignProjectAdminReducer from "./assign_project_admin_reducer";
import AssignUserToProjectReducer from "./assign_user_to_project_reducer";
import BootstrapFirstOrgAdminReducer from "./bootstrap_first_org_admin_reducer";
import BootstrapServerModuleReducer from "./bootstrap_server_module_reducer";
import BulkAssignUsersToProjectReducer from "./bulk_assign_users_to_project_reducer";
import CancelInvitationReducer from "./cancel_invitation_reducer";
import CheckDeploymentStatusReducer from "./check_deployment_status_reducer";
import ConfigureRoleSyncTimerReducer from "./configure_role_sync_timer_reducer";
import CreateProjectReducer from "./create_project_reducer";
import CreateShareLinkReducer from "./create_share_link_reducer";
import DeleteDeploymentReducer from "./delete_deployment_reducer";
import DeleteImageReducer from "./delete_image_reducer";
import DeleteServiceReducer from "./delete_service_reducer";
import DeployProjectReducer from "./deploy_project_reducer";
import DeployProjectWithOptionsReducer from "./deploy_project_with_options_reducer";
import DeregisterServiceReducer from "./deregister_service_reducer";
import EnsureAiBudgetConfigReducer from "./ensure_ai_budget_config_reducer";
import ForceDeleteDeploymentReducer from "./force_delete_deployment_reducer";
import ForceDeleteServerModuleReducer from "./force_delete_server_module_reducer";
import GetWorkosConfigInfoReducer from "./get_workos_config_info_reducer";
import ImportMovedProjectReducer from "./import_moved_project_reducer";
import InviteProjectUserByEmailReducer from "./invite_project_user_by_email_reducer";
import MarkImageUpdatedReducer from "./mark_image_updated_reducer";
import NotifyRollbackCompletedReducer from "./notify_rollback_completed_reducer";
import NotifyUpdatesAvailableReducer from "./notify_updates_available_reducer";
import NotifyUpdatesCompletedReducer from "./notify_updates_completed_reducer";
import PostRestoreNormalizeReducer from "./post_restore_normalize_reducer";
import ProvisionBuiltinAgentReducer from "./provision_builtin_agent_reducer";
import ProvisionNewServiceTokenReducer from "./provision_new_service_token_reducer";
import ProvisionSimulatorTokenReducer from "./provision_simulator_token_reducer";
import PruneOrphanDeploymentsReducer from "./prune_orphan_deployments_reducer";
import PurgeOldLogsReducer from "./purge_old_logs_reducer";
import ReactivateProjectReducer from "./reactivate_project_reducer";
import RecordAgentLlmUsageReducer from "./record_agent_llm_usage_reducer";
import RecordAgentLlmUsageV2Reducer from "./record_agent_llm_usage_v_2_reducer";
import RecordAgentLlmUsageV3Reducer from "./record_agent_llm_usage_v_3_reducer";
import RedeemShareLinkReducer from "./redeem_share_link_reducer";
import RedeployDeploymentReducer from "./redeploy_deployment_reducer";
import RegisterImageReducer from "./register_image_reducer";
import RegisterServerModuleReducer from "./register_server_module_reducer";
import RegisterServiceReducer from "./register_service_reducer";
import RemoveAdminUserReducer from "./remove_admin_user_reducer";
import RemoveMovedProjectReducer from "./remove_moved_project_reducer";
import RemoveOrgBackgroundLayerReducer from "./remove_org_background_layer_reducer";
import RemovePreapprovedEmailReducer from "./remove_preapproved_email_reducer";
import RemoveUserFromProjectReducer from "./remove_user_from_project_reducer";
import ReportDeploymentStatusReducer from "./report_deployment_status_reducer";
import ReportModulePublishResultReducer from "./report_module_publish_result_reducer";
import ReportServiceLogsReducer from "./report_service_logs_reducer";
import ReprovisionServiceTokenReducer from "./reprovision_service_token_reducer";
import RequestFreeProjectReducer from "./request_free_project_reducer";
import RequestModuleRefreshReducer from "./request_module_refresh_reducer";
import RequestServiceDeploymentReducer from "./request_service_deployment_reducer";
import RestartDeploymentReducer from "./restart_deployment_reducer";
import ResyncProjectRolesReducer from "./resync_project_roles_reducer";
import RevokeServerModuleReducer from "./revoke_server_module_reducer";
import RevokeServiceTokenReducer from "./revoke_service_token_reducer";
import RollbackProjectModuleReducer from "./rollback_project_module_reducer";
import RotateServiceTokenReducer from "./rotate_service_token_reducer";
import SelfRegisterReducer from "./self_register_reducer";
import ServiceHeartbeatReducer from "./service_heartbeat_reducer";
import SetAgentDbConfigReducer from "./set_agent_db_config_reducer";
import SetAiBudgetConfigReducer from "./set_ai_budget_config_reducer";
import SetDeploymentConfigReducer from "./set_deployment_config_reducer";
import SetDeploymentPolicyReducer from "./set_deployment_policy_reducer";
import SetLlmModelWeightReducer from "./set_llm_model_weight_reducer";
import SetOrgBackgroundLayerReducer from "./set_org_background_layer_reducer";
import SetOrgProjectUpdatePolicyReducer from "./set_org_project_update_policy_reducer";
import SetOrgRetentionReducer from "./set_org_retention_reducer";
import SetOrgUpdatePolicyReducer from "./set_org_update_policy_reducer";
import SetProjectAssetReadScopesReducer from "./set_project_asset_read_scopes_reducer";
import SetProjectAutoUpdateReducer from "./set_project_auto_update_reducer";
import SetProjectPublicReducer from "./set_project_public_reducer";
import SetProjectRetentionReducer from "./set_project_retention_reducer";
import SetProjectUpdatePolicyReducer from "./set_project_update_policy_reducer";
import SetReportUsageConfigReducer from "./set_report_usage_config_reducer";
import SetSelfServeEnabledReducer from "./set_self_serve_enabled_reducer";
import SetServerModuleMembershipSubscriptionReducer from "./set_server_module_membership_subscription_reducer";
import SetServiceActsForUsersReducer from "./set_service_acts_for_users_reducer";
import SetServiceImageDigestReducer from "./set_service_image_digest_reducer";
import SetServiceTokenReducer from "./set_service_token_reducer";
import SetWorkosConfigReducer from "./set_workos_config_reducer";
import StartContainerStatusPollReducer from "./start_container_status_poll_reducer";
import StartDeploymentReducer from "./start_deployment_reducer";
import StartDeploymentHealthTimerReducer from "./start_deployment_health_timer_reducer";
import StartRoleSyncTimerReducer from "./start_role_sync_timer_reducer";
import StopContainerStatusPollReducer from "./stop_container_status_poll_reducer";
import StopDeploymentReducer from "./stop_deployment_reducer";
import StopDeploymentHealthTimerReducer from "./stop_deployment_health_timer_reducer";
import StopRoleSyncTimerReducer from "./stop_role_sync_timer_reducer";
import SuspendProjectReducer from "./suspend_project_reducer";
import SyncOrgModuleStateReducer from "./sync_org_module_state_reducer";
import UpdateReducer from "./update_reducer";
import UpdateImageReducer from "./update_image_reducer";
import UpdateProjectReducer from "./update_project_reducer";
import UpdateProjectModulesReducer from "./update_project_modules_reducer";
import UpdateProjectUserRoleReducer from "./update_project_user_role_reducer";
import UpdateServiceDisplayNameReducer from "./update_service_display_name_reducer";
import UpdateServiceSecretsReducer from "./update_service_secrets_reducer";
import UpdateUsernameReducer from "./update_username_reducer";

// Import all procedure arg schemas
import * as AdminListProjectAssignmentsProcedure from "./admin_list_project_assignments_procedure";
import * as AdminListProjectUsersProcedure from "./admin_list_project_users_procedure";
import * as AdminListProjectsProcedure from "./admin_list_projects_procedure";
import * as AdminListRetentionProcedure from "./admin_list_retention_procedure";
import * as ClearDatabaseHistoryProcedure from "./clear_database_history_procedure";
import * as DeleteProjectProcedure from "./delete_project_procedure";
import * as ExportProjectForMoveProcedure from "./export_project_for_move_procedure";
import * as GenerateAcrPushTokenNowProcedure from "./generate_acr_push_token_now_procedure";
import * as GenerateAcrPushTokenWithTtlProcedure from "./generate_acr_push_token_with_ttl_procedure";
import * as GetProjectLocationsProcedure from "./get_project_locations_procedure";
import * as GetServiceActsForUsersProcedure from "./get_service_acts_for_users_procedure";
import * as GetServiceLogsProcedure from "./get_service_logs_procedure";
import * as JoinProjectSessionProcedure from "./join_project_session_procedure";
import * as ListProjectShareLinksProcedure from "./list_project_share_links_procedure";
import * as MintDbTokenProcedure from "./mint_db_token_procedure";
import * as RenewServiceTokenNowProcedure from "./renew_service_token_now_procedure";
import * as RevealServiceConfigProcedure from "./reveal_service_config_procedure";

// Import all table schema definitions
import AdminUserRow from "./admin_user_table";
import AiBudgetStateRow from "./ai_budget_state_table";
import DeploymentLogRow from "./deployment_log_table";
import InvitationRow from "./invitation_table";
import ModuleDeploymentRow from "./module_deployment_table";
import ModuleDeploymentHistoryRow from "./module_deployment_history_table";
import ModuleUpdateResultRow from "./module_update_result_table";
import MyOrgBackgroundLayerKeysRow from "./my_org_background_layer_keys_table";
import MyProjectUsersRow from "./my_project_users_table";
import MyProjectsRow from "./my_projects_table";
import OrgBackgroundLayerRow from "./org_background_layer_table";
import OrgModuleDeploymentRow from "./org_module_deployment_table";
import OrgModuleDeploymentHistoryRow from "./org_module_deployment_history_table";
import OrgUpdatePolicyConfigRow from "./org_update_policy_config_table";
import PendingModuleUpdateRow from "./pending_module_update_table";
import PendingUserRow from "./pending_user_table";
import RegisteredServiceRow from "./registered_service_table";
import RolePropagationLogRow from "./role_propagation_log_table";
import ServerModuleRow from "./server_module_table";
import ServiceDeploymentRow from "./service_deployment_table";
import ServiceImageRow from "./service_image_table";
import ServiceLogRow from "./service_log_table";
import ServiceProjectsRow from "./service_projects_table";
import ServiceTokenAuditLogRow from "./service_token_audit_log_table";
import ServiceTokenMetadataRow from "./service_token_metadata_table";
import SkippedModuleUpdateRow from "./skipped_module_update_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  adminUser: __table({
    name: 'admin_user',
    indexes: [
      { accessor: 'identity', name: 'admin_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'admin_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, AdminUserRow),
  aiBudgetState: __table({
    name: 'ai_budget_state',
    indexes: [
      { accessor: 'id', name: 'ai_budget_state_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'ai_budget_state_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AiBudgetStateRow),
  deploymentLog: __table({
    name: 'deployment_log',
    indexes: [
      { accessor: 'id', name: 'deployment_log_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'deployment_log_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DeploymentLogRow),
  invitation: __table({
    name: 'invitation',
    indexes: [
      { accessor: 'id', name: 'invitation_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'invitation_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'user_identity', name: 'invitation_user_identity_idx_btree', algorithm: 'btree', columns: [
        'userIdentity',
      ] },
    ],
    constraints: [
      { name: 'invitation_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, InvitationRow),
  moduleDeployment: __table({
    name: 'module_deployment',
    indexes: [
      { accessor: 'id', name: 'module_deployment_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'module_deployment_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'module_deployment_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ModuleDeploymentRow),
  moduleDeploymentHistory: __table({
    name: 'module_deployment_history',
    indexes: [
      { accessor: 'id', name: 'module_deployment_history_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'module_deployment_history_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'module_deployment_history_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ModuleDeploymentHistoryRow),
  moduleUpdateResult: __table({
    name: 'module_update_result',
    indexes: [
      { accessor: 'id', name: 'module_update_result_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'module_update_result_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ModuleUpdateResultRow),
  orgBackgroundLayer: __table({
    name: 'org_background_layer',
    indexes: [
      { accessor: 'layer_id', name: 'org_background_layer_layer_id_idx_btree', algorithm: 'btree', columns: [
        'layerId',
      ] },
    ],
    constraints: [
      { name: 'org_background_layer_layer_id_key', constraint: 'unique', columns: ['layerId'] },
    ],
  }, OrgBackgroundLayerRow),
  orgModuleDeployment: __table({
    name: 'org_module_deployment',
    indexes: [
      { accessor: 'database_name', name: 'org_module_deployment_database_name_idx_btree', algorithm: 'btree', columns: [
        'databaseName',
      ] },
      { accessor: 'id', name: 'org_module_deployment_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'org_module_deployment_database_name_key', constraint: 'unique', columns: ['databaseName'] },
      { name: 'org_module_deployment_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, OrgModuleDeploymentRow),
  orgModuleDeploymentHistory: __table({
    name: 'org_module_deployment_history',
    indexes: [
      { accessor: 'id', name: 'org_module_deployment_history_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'org_module_deployment_history_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, OrgModuleDeploymentHistoryRow),
  orgUpdatePolicyConfig: __table({
    name: 'org_update_policy_config',
    indexes: [
      { accessor: 'id', name: 'org_update_policy_config_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'org_update_policy_config_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, OrgUpdatePolicyConfigRow),
  pendingModuleUpdate: __table({
    name: 'pending_module_update',
    indexes: [
      { accessor: 'id', name: 'pending_module_update_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'pending_module_update_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PendingModuleUpdateRow),
  pendingUser: __table({
    name: 'pending_user',
    indexes: [
      { accessor: 'identity', name: 'pending_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'pending_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PendingUserRow),
  registeredService: __table({
    name: 'registered_service',
    indexes: [
      { accessor: 'id', name: 'registered_service_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'identity_hex', name: 'registered_service_identity_hex_idx_btree', algorithm: 'btree', columns: [
        'identityHex',
      ] },
      { accessor: 'name', name: 'registered_service_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'project_id', name: 'registered_service_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'registered_service_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'registered_service_name_key', constraint: 'unique', columns: ['name'] },
    ],
  }, RegisteredServiceRow),
  rolePropagationLog: __table({
    name: 'role_propagation_log',
    indexes: [
      { accessor: 'id', name: 'role_propagation_log_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'role_propagation_log_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RolePropagationLogRow),
  serverModule: __table({
    name: 'server_module',
    indexes: [
      { accessor: 'db_name', name: 'server_module_db_name_idx_btree', algorithm: 'btree', columns: [
        'dbName',
      ] },
      { accessor: 'id', name: 'server_module_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'service_id', name: 'server_module_service_id_idx_btree', algorithm: 'btree', columns: [
        'serviceId',
      ] },
    ],
    constraints: [
      { name: 'server_module_db_name_key', constraint: 'unique', columns: ['dbName'] },
      { name: 'server_module_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ServerModuleRow),
  serviceDeployment: __table({
    name: 'service_deployment',
    indexes: [
      { accessor: 'container_app_name', name: 'service_deployment_container_app_name_idx_btree', algorithm: 'btree', columns: [
        'containerAppName',
      ] },
      { accessor: 'id', name: 'service_deployment_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'image_id', name: 'service_deployment_image_id_idx_btree', algorithm: 'btree', columns: [
        'imageId',
      ] },
      { accessor: 'service_id', name: 'service_deployment_service_id_idx_btree', algorithm: 'btree', columns: [
        'serviceId',
      ] },
    ],
    constraints: [
      { name: 'service_deployment_container_app_name_key', constraint: 'unique', columns: ['containerAppName'] },
      { name: 'service_deployment_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ServiceDeploymentRow),
  serviceImage: __table({
    name: 'service_image',
    indexes: [
      { accessor: 'id', name: 'service_image_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'name', name: 'service_image_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
    ],
    constraints: [
      { name: 'service_image_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'service_image_name_key', constraint: 'unique', columns: ['name'] },
    ],
  }, ServiceImageRow),
  serviceLog: __table({
    name: 'service_log',
    indexes: [
      { accessor: 'service_id', name: 'service_log_service_id_idx_btree', algorithm: 'btree', columns: [
        'serviceId',
      ] },
    ],
    constraints: [
      { name: 'service_log_service_id_key', constraint: 'unique', columns: ['serviceId'] },
    ],
  }, ServiceLogRow),
  serviceTokenAuditLog: __table({
    name: 'service_token_audit_log',
    indexes: [
      { accessor: 'id', name: 'service_token_audit_log_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'token_id', name: 'service_token_audit_log_token_id_idx_btree', algorithm: 'btree', columns: [
        'tokenId',
      ] },
    ],
    constraints: [
      { name: 'service_token_audit_log_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ServiceTokenAuditLogRow),
  serviceTokenMetadata: __table({
    name: 'service_token_metadata',
    indexes: [
      { accessor: 'id', name: 'service_token_metadata_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'service_token_metadata_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'service_token_metadata_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ServiceTokenMetadataRow),
  skippedModuleUpdate: __table({
    name: 'skipped_module_update',
    indexes: [
      { accessor: 'id', name: 'skipped_module_update_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'skipped_module_update_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'skipped_module_update_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, SkippedModuleUpdateRow),
  myOrgBackgroundLayerKeys: __table({
    name: 'my_org_background_layer_keys',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgBackgroundLayerKeysRow),
  myProjectUsers: __table({
    name: 'my_project_users',
    indexes: [
    ],
    constraints: [
    ],
  }, MyProjectUsersRow),
  myProjects: __table({
    name: 'my_projects',
    indexes: [
    ],
    constraints: [
    ],
  }, MyProjectsRow),
  serviceProjects: __table({
    name: 'service_projects',
    indexes: [
    ],
    constraints: [
    ],
  }, ServiceProjectsRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("accept_invitation", AcceptInvitationReducer),
  __reducerSchema("add_preapproved_email", AddPreapprovedEmailReducer),
  __reducerSchema("apply_single_skipped_update", ApplySingleSkippedUpdateReducer),
  __reducerSchema("approve_module_update", ApproveModuleUpdateReducer),
  __reducerSchema("approve_module_update_clear", ApproveModuleUpdateClearReducer),
  __reducerSchema("approve_module_updates", ApproveModuleUpdatesReducer),
  __reducerSchema("approve_module_updates_clear", ApproveModuleUpdatesClearReducer),
  __reducerSchema("archive_project", ArchiveProjectReducer),
  __reducerSchema("assign_admin_role", AssignAdminRoleReducer),
  __reducerSchema("assign_project_admin", AssignProjectAdminReducer),
  __reducerSchema("assign_user_to_project", AssignUserToProjectReducer),
  __reducerSchema("bootstrap_first_org_admin", BootstrapFirstOrgAdminReducer),
  __reducerSchema("bootstrap_server_module", BootstrapServerModuleReducer),
  __reducerSchema("bulk_assign_users_to_project", BulkAssignUsersToProjectReducer),
  __reducerSchema("cancel_invitation", CancelInvitationReducer),
  __reducerSchema("check_deployment_status", CheckDeploymentStatusReducer),
  __reducerSchema("configure_role_sync_timer", ConfigureRoleSyncTimerReducer),
  __reducerSchema("create_project", CreateProjectReducer),
  __reducerSchema("create_share_link", CreateShareLinkReducer),
  __reducerSchema("delete_deployment", DeleteDeploymentReducer),
  __reducerSchema("delete_image", DeleteImageReducer),
  __reducerSchema("delete_service", DeleteServiceReducer),
  __reducerSchema("deploy_project", DeployProjectReducer),
  __reducerSchema("deploy_project_with_options", DeployProjectWithOptionsReducer),
  __reducerSchema("deregister_service", DeregisterServiceReducer),
  __reducerSchema("ensure_ai_budget_config", EnsureAiBudgetConfigReducer),
  __reducerSchema("force_delete_deployment", ForceDeleteDeploymentReducer),
  __reducerSchema("force_delete_server_module", ForceDeleteServerModuleReducer),
  __reducerSchema("get_workos_config_info", GetWorkosConfigInfoReducer),
  __reducerSchema("import_moved_project", ImportMovedProjectReducer),
  __reducerSchema("invite_project_user_by_email", InviteProjectUserByEmailReducer),
  __reducerSchema("mark_image_updated", MarkImageUpdatedReducer),
  __reducerSchema("notify_rollback_completed", NotifyRollbackCompletedReducer),
  __reducerSchema("notify_updates_available", NotifyUpdatesAvailableReducer),
  __reducerSchema("notify_updates_completed", NotifyUpdatesCompletedReducer),
  __reducerSchema("post_restore_normalize", PostRestoreNormalizeReducer),
  __reducerSchema("provision_builtin_agent", ProvisionBuiltinAgentReducer),
  __reducerSchema("provision_new_service_token", ProvisionNewServiceTokenReducer),
  __reducerSchema("provision_simulator_token", ProvisionSimulatorTokenReducer),
  __reducerSchema("prune_orphan_deployments", PruneOrphanDeploymentsReducer),
  __reducerSchema("purge_old_logs", PurgeOldLogsReducer),
  __reducerSchema("reactivate_project", ReactivateProjectReducer),
  __reducerSchema("record_agent_llm_usage", RecordAgentLlmUsageReducer),
  __reducerSchema("record_agent_llm_usage_v_2", RecordAgentLlmUsageV2Reducer),
  __reducerSchema("record_agent_llm_usage_v_3", RecordAgentLlmUsageV3Reducer),
  __reducerSchema("redeem_share_link", RedeemShareLinkReducer),
  __reducerSchema("redeploy_deployment", RedeployDeploymentReducer),
  __reducerSchema("register_image", RegisterImageReducer),
  __reducerSchema("register_server_module", RegisterServerModuleReducer),
  __reducerSchema("register_service", RegisterServiceReducer),
  __reducerSchema("remove_admin_user", RemoveAdminUserReducer),
  __reducerSchema("remove_moved_project", RemoveMovedProjectReducer),
  __reducerSchema("remove_org_background_layer", RemoveOrgBackgroundLayerReducer),
  __reducerSchema("remove_preapproved_email", RemovePreapprovedEmailReducer),
  __reducerSchema("remove_user_from_project", RemoveUserFromProjectReducer),
  __reducerSchema("report_deployment_status", ReportDeploymentStatusReducer),
  __reducerSchema("report_module_publish_result", ReportModulePublishResultReducer),
  __reducerSchema("report_service_logs", ReportServiceLogsReducer),
  __reducerSchema("reprovision_service_token", ReprovisionServiceTokenReducer),
  __reducerSchema("request_free_project", RequestFreeProjectReducer),
  __reducerSchema("request_module_refresh", RequestModuleRefreshReducer),
  __reducerSchema("request_service_deployment", RequestServiceDeploymentReducer),
  __reducerSchema("restart_deployment", RestartDeploymentReducer),
  __reducerSchema("resync_project_roles", ResyncProjectRolesReducer),
  __reducerSchema("revoke_server_module", RevokeServerModuleReducer),
  __reducerSchema("revoke_service_token", RevokeServiceTokenReducer),
  __reducerSchema("rollback_project_module", RollbackProjectModuleReducer),
  __reducerSchema("rotate_service_token", RotateServiceTokenReducer),
  __reducerSchema("self_register", SelfRegisterReducer),
  __reducerSchema("service_heartbeat", ServiceHeartbeatReducer),
  __reducerSchema("set_agent_db_config", SetAgentDbConfigReducer),
  __reducerSchema("set_ai_budget_config", SetAiBudgetConfigReducer),
  __reducerSchema("set_deployment_config", SetDeploymentConfigReducer),
  __reducerSchema("set_deployment_policy", SetDeploymentPolicyReducer),
  __reducerSchema("set_llm_model_weight", SetLlmModelWeightReducer),
  __reducerSchema("set_org_background_layer", SetOrgBackgroundLayerReducer),
  __reducerSchema("set_org_project_update_policy", SetOrgProjectUpdatePolicyReducer),
  __reducerSchema("set_org_retention", SetOrgRetentionReducer),
  __reducerSchema("set_org_update_policy", SetOrgUpdatePolicyReducer),
  __reducerSchema("set_project_asset_read_scopes", SetProjectAssetReadScopesReducer),
  __reducerSchema("set_project_auto_update", SetProjectAutoUpdateReducer),
  __reducerSchema("set_project_public", SetProjectPublicReducer),
  __reducerSchema("set_project_retention", SetProjectRetentionReducer),
  __reducerSchema("set_project_update_policy", SetProjectUpdatePolicyReducer),
  __reducerSchema("set_report_usage_config", SetReportUsageConfigReducer),
  __reducerSchema("set_self_serve_enabled", SetSelfServeEnabledReducer),
  __reducerSchema("set_server_module_membership_subscription", SetServerModuleMembershipSubscriptionReducer),
  __reducerSchema("set_service_acts_for_users", SetServiceActsForUsersReducer),
  __reducerSchema("set_service_image_digest", SetServiceImageDigestReducer),
  __reducerSchema("set_service_token", SetServiceTokenReducer),
  __reducerSchema("set_workos_config", SetWorkosConfigReducer),
  __reducerSchema("start_container_status_poll", StartContainerStatusPollReducer),
  __reducerSchema("start_deployment", StartDeploymentReducer),
  __reducerSchema("start_deployment_health_timer", StartDeploymentHealthTimerReducer),
  __reducerSchema("start_role_sync_timer", StartRoleSyncTimerReducer),
  __reducerSchema("stop_container_status_poll", StopContainerStatusPollReducer),
  __reducerSchema("stop_deployment", StopDeploymentReducer),
  __reducerSchema("stop_deployment_health_timer", StopDeploymentHealthTimerReducer),
  __reducerSchema("stop_role_sync_timer", StopRoleSyncTimerReducer),
  __reducerSchema("suspend_project", SuspendProjectReducer),
  __reducerSchema("sync_org_module_state", SyncOrgModuleStateReducer),
  __reducerSchema("update", UpdateReducer),
  __reducerSchema("update_image", UpdateImageReducer),
  __reducerSchema("update_project", UpdateProjectReducer),
  __reducerSchema("update_project_modules", UpdateProjectModulesReducer),
  __reducerSchema("update_project_user_role", UpdateProjectUserRoleReducer),
  __reducerSchema("update_service_display_name", UpdateServiceDisplayNameReducer),
  __reducerSchema("update_service_secrets", UpdateServiceSecretsReducer),
  __reducerSchema("update_username", UpdateUsernameReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("admin_list_project_assignments", AdminListProjectAssignmentsProcedure.params, AdminListProjectAssignmentsProcedure.returnType),
  __procedureSchema("admin_list_project_users", AdminListProjectUsersProcedure.params, AdminListProjectUsersProcedure.returnType),
  __procedureSchema("admin_list_projects", AdminListProjectsProcedure.params, AdminListProjectsProcedure.returnType),
  __procedureSchema("admin_list_retention", AdminListRetentionProcedure.params, AdminListRetentionProcedure.returnType),
  __procedureSchema("clear_database_history", ClearDatabaseHistoryProcedure.params, ClearDatabaseHistoryProcedure.returnType),
  __procedureSchema("delete_project", DeleteProjectProcedure.params, DeleteProjectProcedure.returnType),
  __procedureSchema("export_project_for_move", ExportProjectForMoveProcedure.params, ExportProjectForMoveProcedure.returnType),
  __procedureSchema("generate_acr_push_token_now", GenerateAcrPushTokenNowProcedure.params, GenerateAcrPushTokenNowProcedure.returnType),
  __procedureSchema("generate_acr_push_token_with_ttl", GenerateAcrPushTokenWithTtlProcedure.params, GenerateAcrPushTokenWithTtlProcedure.returnType),
  __procedureSchema("get_project_locations", GetProjectLocationsProcedure.params, GetProjectLocationsProcedure.returnType),
  __procedureSchema("get_service_acts_for_users", GetServiceActsForUsersProcedure.params, GetServiceActsForUsersProcedure.returnType),
  __procedureSchema("get_service_logs", GetServiceLogsProcedure.params, GetServiceLogsProcedure.returnType),
  __procedureSchema("join_project_session", JoinProjectSessionProcedure.params, JoinProjectSessionProcedure.returnType),
  __procedureSchema("list_project_share_links", ListProjectShareLinksProcedure.params, ListProjectShareLinksProcedure.returnType),
  __procedureSchema("mint_db_token", MintDbTokenProcedure.params, MintDbTokenProcedure.returnType),
  __procedureSchema("renew_service_token_now", RenewServiceTokenNowProcedure.params, RenewServiceTokenNowProcedure.returnType),
  __procedureSchema("reveal_service_config", RevealServiceConfigProcedure.params, RevealServiceConfigProcedure.returnType),
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `adminUser` instead. This alias will be removed in the next major version. */
    readonly "admin_user": Omit<typeof tablesSchema.schemaType.tables["adminUser"], "accessorName"> & { readonly accessorName: "admin_user" };
    /** @deprecated Use `aiBudgetState` instead. This alias will be removed in the next major version. */
    readonly "ai_budget_state": Omit<typeof tablesSchema.schemaType.tables["aiBudgetState"], "accessorName"> & { readonly accessorName: "ai_budget_state" };
    /** @deprecated Use `deploymentLog` instead. This alias will be removed in the next major version. */
    readonly "deployment_log": Omit<typeof tablesSchema.schemaType.tables["deploymentLog"], "accessorName"> & { readonly accessorName: "deployment_log" };
    /** @deprecated Use `moduleDeployment` instead. This alias will be removed in the next major version. */
    readonly "module_deployment": Omit<typeof tablesSchema.schemaType.tables["moduleDeployment"], "accessorName"> & { readonly accessorName: "module_deployment" };
    /** @deprecated Use `moduleDeploymentHistory` instead. This alias will be removed in the next major version. */
    readonly "module_deployment_history": Omit<typeof tablesSchema.schemaType.tables["moduleDeploymentHistory"], "accessorName"> & { readonly accessorName: "module_deployment_history" };
    /** @deprecated Use `moduleUpdateResult` instead. This alias will be removed in the next major version. */
    readonly "module_update_result": Omit<typeof tablesSchema.schemaType.tables["moduleUpdateResult"], "accessorName"> & { readonly accessorName: "module_update_result" };
    /** @deprecated Use `orgBackgroundLayer` instead. This alias will be removed in the next major version. */
    readonly "org_background_layer": Omit<typeof tablesSchema.schemaType.tables["orgBackgroundLayer"], "accessorName"> & { readonly accessorName: "org_background_layer" };
    /** @deprecated Use `orgModuleDeployment` instead. This alias will be removed in the next major version. */
    readonly "org_module_deployment": Omit<typeof tablesSchema.schemaType.tables["orgModuleDeployment"], "accessorName"> & { readonly accessorName: "org_module_deployment" };
    /** @deprecated Use `orgModuleDeploymentHistory` instead. This alias will be removed in the next major version. */
    readonly "org_module_deployment_history": Omit<typeof tablesSchema.schemaType.tables["orgModuleDeploymentHistory"], "accessorName"> & { readonly accessorName: "org_module_deployment_history" };
    /** @deprecated Use `orgUpdatePolicyConfig` instead. This alias will be removed in the next major version. */
    readonly "org_update_policy_config": Omit<typeof tablesSchema.schemaType.tables["orgUpdatePolicyConfig"], "accessorName"> & { readonly accessorName: "org_update_policy_config" };
    /** @deprecated Use `pendingModuleUpdate` instead. This alias will be removed in the next major version. */
    readonly "pending_module_update": Omit<typeof tablesSchema.schemaType.tables["pendingModuleUpdate"], "accessorName"> & { readonly accessorName: "pending_module_update" };
    /** @deprecated Use `pendingUser` instead. This alias will be removed in the next major version. */
    readonly "pending_user": Omit<typeof tablesSchema.schemaType.tables["pendingUser"], "accessorName"> & { readonly accessorName: "pending_user" };
    /** @deprecated Use `registeredService` instead. This alias will be removed in the next major version. */
    readonly "registered_service": Omit<typeof tablesSchema.schemaType.tables["registeredService"], "accessorName"> & { readonly accessorName: "registered_service" };
    /** @deprecated Use `rolePropagationLog` instead. This alias will be removed in the next major version. */
    readonly "role_propagation_log": Omit<typeof tablesSchema.schemaType.tables["rolePropagationLog"], "accessorName"> & { readonly accessorName: "role_propagation_log" };
    /** @deprecated Use `serverModule` instead. This alias will be removed in the next major version. */
    readonly "server_module": Omit<typeof tablesSchema.schemaType.tables["serverModule"], "accessorName"> & { readonly accessorName: "server_module" };
    /** @deprecated Use `serviceDeployment` instead. This alias will be removed in the next major version. */
    readonly "service_deployment": Omit<typeof tablesSchema.schemaType.tables["serviceDeployment"], "accessorName"> & { readonly accessorName: "service_deployment" };
    /** @deprecated Use `serviceImage` instead. This alias will be removed in the next major version. */
    readonly "service_image": Omit<typeof tablesSchema.schemaType.tables["serviceImage"], "accessorName"> & { readonly accessorName: "service_image" };
    /** @deprecated Use `serviceLog` instead. This alias will be removed in the next major version. */
    readonly "service_log": Omit<typeof tablesSchema.schemaType.tables["serviceLog"], "accessorName"> & { readonly accessorName: "service_log" };
    /** @deprecated Use `serviceTokenAuditLog` instead. This alias will be removed in the next major version. */
    readonly "service_token_audit_log": Omit<typeof tablesSchema.schemaType.tables["serviceTokenAuditLog"], "accessorName"> & { readonly accessorName: "service_token_audit_log" };
    /** @deprecated Use `serviceTokenMetadata` instead. This alias will be removed in the next major version. */
    readonly "service_token_metadata": Omit<typeof tablesSchema.schemaType.tables["serviceTokenMetadata"], "accessorName"> & { readonly accessorName: "service_token_metadata" };
    /** @deprecated Use `skippedModuleUpdate` instead. This alias will be removed in the next major version. */
    readonly "skipped_module_update": Omit<typeof tablesSchema.schemaType.tables["skippedModuleUpdate"], "accessorName"> & { readonly accessorName: "skipped_module_update" };
    /** @deprecated Use `myOrgBackgroundLayerKeys` instead. This alias will be removed in the next major version. */
    readonly "my_org_background_layer_keys": Omit<typeof tablesSchema.schemaType.tables["myOrgBackgroundLayerKeys"], "accessorName"> & { readonly accessorName: "my_org_background_layer_keys" };
    /** @deprecated Use `myProjectUsers` instead. This alias will be removed in the next major version. */
    readonly "my_project_users": Omit<typeof tablesSchema.schemaType.tables["myProjectUsers"], "accessorName"> & { readonly accessorName: "my_project_users" };
    /** @deprecated Use `myProjects` instead. This alias will be removed in the next major version. */
    readonly "my_projects": Omit<typeof tablesSchema.schemaType.tables["myProjects"], "accessorName"> & { readonly accessorName: "my_projects" };
    /** @deprecated Use `serviceProjects` instead. This alias will be removed in the next major version. */
    readonly "service_projects": Omit<typeof tablesSchema.schemaType.tables["serviceProjects"], "accessorName"> & { readonly accessorName: "service_projects" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.14.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "admin_user": "adminUser",
  "ai_budget_state": "aiBudgetState",
  "deployment_log": "deploymentLog",
  "module_deployment": "moduleDeployment",
  "module_deployment_history": "moduleDeploymentHistory",
  "module_update_result": "moduleUpdateResult",
  "org_background_layer": "orgBackgroundLayer",
  "org_module_deployment": "orgModuleDeployment",
  "org_module_deployment_history": "orgModuleDeploymentHistory",
  "org_update_policy_config": "orgUpdatePolicyConfig",
  "pending_module_update": "pendingModuleUpdate",
  "pending_user": "pendingUser",
  "registered_service": "registeredService",
  "role_propagation_log": "rolePropagationLog",
  "server_module": "serverModule",
  "service_deployment": "serviceDeployment",
  "service_image": "serviceImage",
  "service_log": "serviceLog",
  "service_token_audit_log": "serviceTokenAuditLog",
  "service_token_metadata": "serviceTokenMetadata",
  "skipped_module_update": "skippedModuleUpdate",
  "my_org_background_layer_keys": "myOrgBackgroundLayerKeys",
  "my_project_users": "myProjectUsers",
  "my_projects": "myProjects",
  "service_projects": "serviceProjects",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `adminUser` instead. This alias will be removed in the next major version. */
  readonly "admin_user": __DbViewBase["adminUser"];
  /** @deprecated Use `aiBudgetState` instead. This alias will be removed in the next major version. */
  readonly "ai_budget_state": __DbViewBase["aiBudgetState"];
  /** @deprecated Use `deploymentLog` instead. This alias will be removed in the next major version. */
  readonly "deployment_log": __DbViewBase["deploymentLog"];
  /** @deprecated Use `moduleDeployment` instead. This alias will be removed in the next major version. */
  readonly "module_deployment": __DbViewBase["moduleDeployment"];
  /** @deprecated Use `moduleDeploymentHistory` instead. This alias will be removed in the next major version. */
  readonly "module_deployment_history": __DbViewBase["moduleDeploymentHistory"];
  /** @deprecated Use `moduleUpdateResult` instead. This alias will be removed in the next major version. */
  readonly "module_update_result": __DbViewBase["moduleUpdateResult"];
  /** @deprecated Use `orgBackgroundLayer` instead. This alias will be removed in the next major version. */
  readonly "org_background_layer": __DbViewBase["orgBackgroundLayer"];
  /** @deprecated Use `orgModuleDeployment` instead. This alias will be removed in the next major version. */
  readonly "org_module_deployment": __DbViewBase["orgModuleDeployment"];
  /** @deprecated Use `orgModuleDeploymentHistory` instead. This alias will be removed in the next major version. */
  readonly "org_module_deployment_history": __DbViewBase["orgModuleDeploymentHistory"];
  /** @deprecated Use `orgUpdatePolicyConfig` instead. This alias will be removed in the next major version. */
  readonly "org_update_policy_config": __DbViewBase["orgUpdatePolicyConfig"];
  /** @deprecated Use `pendingModuleUpdate` instead. This alias will be removed in the next major version. */
  readonly "pending_module_update": __DbViewBase["pendingModuleUpdate"];
  /** @deprecated Use `pendingUser` instead. This alias will be removed in the next major version. */
  readonly "pending_user": __DbViewBase["pendingUser"];
  /** @deprecated Use `registeredService` instead. This alias will be removed in the next major version. */
  readonly "registered_service": __DbViewBase["registeredService"];
  /** @deprecated Use `rolePropagationLog` instead. This alias will be removed in the next major version. */
  readonly "role_propagation_log": __DbViewBase["rolePropagationLog"];
  /** @deprecated Use `serverModule` instead. This alias will be removed in the next major version. */
  readonly "server_module": __DbViewBase["serverModule"];
  /** @deprecated Use `serviceDeployment` instead. This alias will be removed in the next major version. */
  readonly "service_deployment": __DbViewBase["serviceDeployment"];
  /** @deprecated Use `serviceImage` instead. This alias will be removed in the next major version. */
  readonly "service_image": __DbViewBase["serviceImage"];
  /** @deprecated Use `serviceLog` instead. This alias will be removed in the next major version. */
  readonly "service_log": __DbViewBase["serviceLog"];
  /** @deprecated Use `serviceTokenAuditLog` instead. This alias will be removed in the next major version. */
  readonly "service_token_audit_log": __DbViewBase["serviceTokenAuditLog"];
  /** @deprecated Use `serviceTokenMetadata` instead. This alias will be removed in the next major version. */
  readonly "service_token_metadata": __DbViewBase["serviceTokenMetadata"];
  /** @deprecated Use `skippedModuleUpdate` instead. This alias will be removed in the next major version. */
  readonly "skipped_module_update": __DbViewBase["skippedModuleUpdate"];
  /** @deprecated Use `myOrgBackgroundLayerKeys` instead. This alias will be removed in the next major version. */
  readonly "my_org_background_layer_keys": __DbViewBase["myOrgBackgroundLayerKeys"];
  /** @deprecated Use `myProjectUsers` instead. This alias will be removed in the next major version. */
  readonly "my_project_users": __DbViewBase["myProjectUsers"];
  /** @deprecated Use `myProjects` instead. This alias will be removed in the next major version. */
  readonly "my_projects": __DbViewBase["myProjects"];
  /** @deprecated Use `serviceProjects` instead. This alias will be removed in the next major version. */
  readonly "service_projects": __DbViewBase["serviceProjects"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `adminUser` instead. This alias will be removed in the next major version. */
  readonly "admin_user": __TablesBase["adminUser"];
  /** @deprecated Use `aiBudgetState` instead. This alias will be removed in the next major version. */
  readonly "ai_budget_state": __TablesBase["aiBudgetState"];
  /** @deprecated Use `deploymentLog` instead. This alias will be removed in the next major version. */
  readonly "deployment_log": __TablesBase["deploymentLog"];
  /** @deprecated Use `moduleDeployment` instead. This alias will be removed in the next major version. */
  readonly "module_deployment": __TablesBase["moduleDeployment"];
  /** @deprecated Use `moduleDeploymentHistory` instead. This alias will be removed in the next major version. */
  readonly "module_deployment_history": __TablesBase["moduleDeploymentHistory"];
  /** @deprecated Use `moduleUpdateResult` instead. This alias will be removed in the next major version. */
  readonly "module_update_result": __TablesBase["moduleUpdateResult"];
  /** @deprecated Use `orgBackgroundLayer` instead. This alias will be removed in the next major version. */
  readonly "org_background_layer": __TablesBase["orgBackgroundLayer"];
  /** @deprecated Use `orgModuleDeployment` instead. This alias will be removed in the next major version. */
  readonly "org_module_deployment": __TablesBase["orgModuleDeployment"];
  /** @deprecated Use `orgModuleDeploymentHistory` instead. This alias will be removed in the next major version. */
  readonly "org_module_deployment_history": __TablesBase["orgModuleDeploymentHistory"];
  /** @deprecated Use `orgUpdatePolicyConfig` instead. This alias will be removed in the next major version. */
  readonly "org_update_policy_config": __TablesBase["orgUpdatePolicyConfig"];
  /** @deprecated Use `pendingModuleUpdate` instead. This alias will be removed in the next major version. */
  readonly "pending_module_update": __TablesBase["pendingModuleUpdate"];
  /** @deprecated Use `pendingUser` instead. This alias will be removed in the next major version. */
  readonly "pending_user": __TablesBase["pendingUser"];
  /** @deprecated Use `registeredService` instead. This alias will be removed in the next major version. */
  readonly "registered_service": __TablesBase["registeredService"];
  /** @deprecated Use `rolePropagationLog` instead. This alias will be removed in the next major version. */
  readonly "role_propagation_log": __TablesBase["rolePropagationLog"];
  /** @deprecated Use `serverModule` instead. This alias will be removed in the next major version. */
  readonly "server_module": __TablesBase["serverModule"];
  /** @deprecated Use `serviceDeployment` instead. This alias will be removed in the next major version. */
  readonly "service_deployment": __TablesBase["serviceDeployment"];
  /** @deprecated Use `serviceImage` instead. This alias will be removed in the next major version. */
  readonly "service_image": __TablesBase["serviceImage"];
  /** @deprecated Use `serviceLog` instead. This alias will be removed in the next major version. */
  readonly "service_log": __TablesBase["serviceLog"];
  /** @deprecated Use `serviceTokenAuditLog` instead. This alias will be removed in the next major version. */
  readonly "service_token_audit_log": __TablesBase["serviceTokenAuditLog"];
  /** @deprecated Use `serviceTokenMetadata` instead. This alias will be removed in the next major version. */
  readonly "service_token_metadata": __TablesBase["serviceTokenMetadata"];
  /** @deprecated Use `skippedModuleUpdate` instead. This alias will be removed in the next major version. */
  readonly "skipped_module_update": __TablesBase["skippedModuleUpdate"];
  /** @deprecated Use `myOrgBackgroundLayerKeys` instead. This alias will be removed in the next major version. */
  readonly "my_org_background_layer_keys": __TablesBase["myOrgBackgroundLayerKeys"];
  /** @deprecated Use `myProjectUsers` instead. This alias will be removed in the next major version. */
  readonly "my_project_users": __TablesBase["myProjectUsers"];
  /** @deprecated Use `myProjects` instead. This alias will be removed in the next major version. */
  readonly "my_projects": __TablesBase["myProjects"];
  /** @deprecated Use `serviceProjects` instead. This alias will be removed in the next major version. */
  readonly "service_projects": __TablesBase["serviceProjects"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

